import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import SvgIcon from '../svg-icon/svg-icon';

import { EmailInvalid, EmailSent, EmailValid, EmailVerified } from '../../helpers/icon-dictionary';
import messages from './messages';
import css from './index.scss';

const EmailStatus = (props) => {
    const { status } = props;

    const getEmailStatusIcon = () => {
        switch (status.toLowerCase()) {
        case 'invalid':
            return <SvgIcon icon={EmailInvalid} />;
        case 'unverified':
            return <SvgIcon icon={EmailValid} />;
        case 'awaitingverification':
            return <SvgIcon icon={EmailSent} />;
        case 'verified':
            return <SvgIcon icon={EmailVerified} />;
        default:
            return status;
        }
    };

    const getEmailStatusTooltip = () => {
        switch (status.toLowerCase()) {
        case 'invalid':
            return props.intl.formatMessage(messages.invalidTooltip);
        case 'unverified':
            return props.intl.formatMessage(messages.unverifiedTooltip);
        case 'awaitingverification':
            return props.intl.formatMessage(messages.awaitingVerificationTooltip);
        case 'verified':
            return props.intl.formatMessage(messages.verifiedTooltip);
        default:
            return status;
        }
    };

    return (
        <div className={css.container}>
            <div className={css.icon} key={Math.random() * 100} title={getEmailStatusTooltip()}>{getEmailStatusIcon()}</div>
        </div>
    );
};

EmailStatus.propTypes = {
    status: PropTypes.string,
    intl: intlShape.isRequired
};

export default injectIntl(EmailStatus);



// WEBPACK FOOTER //
// ./app/components/email-status/index.js